import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../lib";
class ApiEpMarketingStatus {
}
ApiEpMarketingStatus.retrieve = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/marketing/v1/status`,
    method: "GET",
});
export class ApiEpMarketing {
}
ApiEpMarketing.Status = ApiEpMarketingStatus;
//# sourceMappingURL=marketing.js.map